export default __webpack_public_path__ + "static/media/gears.f18c4d12.png";